import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Button, IconButton } from "@radix-ui/themes";

import { getPaginationItems } from "./index.helpers";

import type { PaginationProps } from "./index.types";

export function Pagination({ currentPage, hasNextPage, isLoading, knownPageCount, onPageChange }: PaginationProps) {
  return (
    <nav className="pagination" aria-label="Sayfalar">
      <IconButton aria-label="Önceki sayfa" disabled={currentPage === 0 || isLoading} onClick={() => onPageChange(currentPage - 1)} type="button" variant="soft"><CaretLeft size={16} /></IconButton>
      <div className="pagination-pages">
        {getPaginationItems(currentPage, knownPageCount).map((item) => typeof item === "number" ? (
          <Button aria-current={item === currentPage ? "page" : undefined} className={item === currentPage ? "active" : undefined} disabled={isLoading} key={item} onClick={() => onPageChange(item)} type="button" variant={item === currentPage ? "solid" : "soft"}>{item + 1}</Button>
        ) : <span aria-hidden="true" key={item}>…</span>)}
      </div>
      <IconButton aria-label="Sonraki sayfa" disabled={!hasNextPage || isLoading} onClick={() => onPageChange(currentPage + 1)} type="button" variant="soft"><CaretRight size={16} /></IconButton>
    </nav>
  );
}
